/*
  Change Coordinator && Change Peer Reviewer:

  This file is responisble for changing both Change Coordinator and Change Peer Reviewer
  form the workflow bar on view CRQ. This is because the logic is incredibly similar. The
  only difference is what field the output of this component saves to and what label of
  the fields the user reads.

*/


import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ModalOptions } from 'AppSrc/core/components/forms/modal-options';
import { SelectCoordinatorGroup } from 'AppSrc/core/components/forms/select-coordinator/select-coordinator-group';
import { SelectCoordinatorTable } from 'AppSrc/core/components/forms/select-coordinator/select-coordinator-table';
import {
  changeCoordinatorForEditCrqId,
  changePeerReviewForEditCrqId,
} from 'AppSrc/core/actions/actions-edit-form';
import {
  CRQ_STATUSES,
  getActorForCrqStatus,
} from 'AppSrc/core/crq/crq-statuses';
import {
  updateEditCrqWithId,
} from 'AppSrc/core/actions/actions-update-edit-form';
import 'AppSrc/core/style/components/view-crq-screen/change-coordinator.css';
import { capitaliseTheStartOfEachWord } from 'AppSrc/core/utility-functions/string-fun';




const getModalOptions = (params) => {
  const {
    closeChangeAssigneeModal,
    changeCoordinator,
    submitSuccess,
  } = params;

  if (submitSuccess === null) {
    return ({
      cancel: closeChangeAssigneeModal,
      confirm: changeCoordinator,
    });
  }
  if (submitSuccess === true) {
    return ({
      rightClose: closeChangeAssigneeModal,
    });
  }
  if (submitSuccess === false) {
    return null;
  }
  // fallback
  return ({
    rightClose: closeChangeAssigneeModal,
  });
};




class ChangeCoordinator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coordinatorGroup: null,
      coordinator: null,
    };

    // we don't want this to change so we set it in the constructor
    this.initialName = props.initialName;
    this.setCoordinatorGroup = this.setCoordinatorGroup.bind(this);
    this.setCoordinator = this.setCoordinator.bind(this);
    this.changeCoordinator = this.changeCoordinator.bind(this);
  }

  setCoordinatorGroup(coordinatorGroup) {
    this.setState(() => ({
      coordinatorGroup,
    }));
  }

  setCoordinator(coordinator) {
    this.setState(() => ({
      coordinator,
    }));
  }

  changeCoordinator() {
    const {
      crqId,
      editingType,
      slaType,
    } = this.props;
    const {
      coordinatorGroup,
      coordinator,
    } = this.state;
    console.log(slaType);
    const groupName = coordinatorGroup ? coordinatorGroup.name : null;
    const coordinatorId = coordinator ? coordinator.id : null;
    const coordinatorName = coordinator ? coordinator.full_name : null;


    if (editingType === CRQ_STATUSES.coordinator) {
      this.props.changeCoordinatorForEditCrqId({
        crqId,
        groupName,
        coordinatorId,
        coordinatorName,
      });
      return null;
    }

    if (editingType === CRQ_STATUSES.peerReview) {
      this.props.changePeerReviewForEditCrqId({
        crqId,
        groupName,
        coordinatorId,
        coordinatorName,
      });
      return null;
    }


    console.error(`Unable to change assignee as editingType: ${editingType} was not recognised`);
    return null;
  }

  render() {
    const {
      network,
      crqId,
      slaType,
      isIcmcrq,
      otherLineOperator,
      closeChangeAssigneeModal,
      submitSuccess,
      editingType,
    } = this.props;

    const {
      coordinatorGroup,
      coordinator,
    } = this.state;


    const groupId = coordinatorGroup ? coordinatorGroup.id : null;
    const coordinatorId = coordinator ? coordinator.id : null;
    const coordinatorName = coordinator ? coordinator.full_name : null;
    console.log('SLA TYPE change peer : ', slaType);
    const modalOptions = getModalOptions({
      closeChangeAssigneeModal,
      changeCoordinator: this.changeCoordinator,
      submitSuccess,
    });

    const readyToSubmit = (crqId && groupId && coordinatorId) ? true : false;

    // if we are selecting a peer reviewer, we should exclude the logged in coordinator
    const excludeLoggedInCoordinator = editingType === CRQ_STATUSES.peerReview;
    const isOlo = otherLineOperator === 'yes' ? true : false;
    const isEmergency = (slaType === '2000' || slaType === 'Emergency') && editingType === CRQ_STATUSES.peerReview ? true : false;
    const actor = (isEmergency && editingType === CRQ_STATUSES.peerReview && !isOlo) ? 'L3 Reviewer' : getActorForCrqStatus(editingType);
    return (
      <>
        {
          submitSuccess === null && (
            <div className="select-assignee-section select-assignee-section-change-coordinator">
              <h2 className="section-title">
                {`Change ${capitaliseTheStartOfEachWord(actor)}`}
              </h2>
              <SelectCoordinatorGroup
                fieldTitle={`Select ${actor}`}
                selectedGroupId={coordinatorGroup ? coordinatorGroup.id : null}
                setGroup={this.setCoordinatorGroup}
                network={network}
                crqType={slaType}
                isEmergency={isEmergency}
                isIcmcrq={isIcmcrq}
                isOlo={isOlo}
                placeholder={`Select ${actor} group`}
              />
              {
                groupId && (
                  <SelectCoordinatorTable
                    key={groupId}
                    network={network}
                    groupId={groupId}
                    setCoordinator={this.setCoordinator}
                    coordinatorId={coordinatorId}
                    excludeLoggedInCoordinator={excludeLoggedInCoordinator}
                  />
                )
              }
            </div>
          )
        }
        {
          submitSuccess === true && (
            <div className="select-assignee-section select-assignee-section-change-coordinator">
              <h2 className="success-title">
                {`You have successfully changed ${actor}`}
              </h2>
              <p className="success-text">
                {`${this.initialName} to ${coordinatorName}`}
              </p>
            </div>
          )
        }
        {
          // if the requests fails we need the user to refresh the page as local permissions should match server permissions
          submitSuccess === false && (
            <div className="select-assignee-section select-assignee-section-change-coordinator">
              <h2 className="error-title">
                {`Failed to change ${actor}`}
              </h2>
              <p className="error-text">
                Please refresh the page and try again
              </p>
            </div>
          )
        }
        {
          modalOptions && (
            <ModalOptions
              modalOptions={modalOptions}
              readyToSubmit={readyToSubmit}
            />
          )
        }
      </>
    );
  }
}


ChangeCoordinator.propTypes = {
  network: PropTypes.string,
  crqId: PropTypes.string,
  slaType: PropTypes.string,
  isIcmcrq: PropTypes.bool,
  otherLineOperator: PropTypes.string,
  initialName: PropTypes.string,
  submitSuccess: PropTypes.bool,
  closeChangeAssigneeModal: PropTypes.func,
  changeCoordinatorForEditCrqId: PropTypes.func,
  changePeerReviewForEditCrqId: PropTypes.func,
  editingType: PropTypes.string,
};




const mapDispatchToProps = (dispatch, ownProps) => ({
  changeCoordinatorForEditCrqId(params) {
    dispatch(changeCoordinatorForEditCrqId(params));
    dispatch(updateEditCrqWithId(ownProps.crqId))
      .then((afterSubmitParams) => {
        ownProps.setSubmitSuccess(afterSubmitParams.success);
      })
      .catch((error) => {
        ownProps.setSubmitSuccess(false);
      });
  },
  changePeerReviewForEditCrqId(params) {
    dispatch(changePeerReviewForEditCrqId(params));
    dispatch(updateEditCrqWithId(ownProps.crqId))
      .then((afterSubmitParams) => {
        ownProps.setSubmitSuccess(afterSubmitParams.success);
      })
      .catch((error) => {
        ownProps.setSubmitSuccess(false);
      });
  },
});

ChangeCoordinator = connect(
  null,
  mapDispatchToProps,
)(ChangeCoordinator);








export { ChangeCoordinator };




